import { render } from "./fullStructure.vue?vue&type=template&id=5ec15187"
import script from "./fullStructure.vue?vue&type=script&lang=js"
export * from "./fullStructure.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/public_web/selllogix-vuecli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__